let fabricObject = function (that, data) {
  let id = data ? (data.id ? data.id : 'psCanvas') : 'psCanvas'
  let color = data ? (data.color ? data.color : 'rgb(58,58,255)') : 'rgb(58,58,255)'
  let fill = data ? (data.fill ? data.fill : null) : null
  let drawWidth = data ? (data.drawWidth ? data.drawWidth : 2) : 2
  let imgInstance = null
  let mouseFrom = {},
    mouseTo = {},
    allObjects = [],
    // canvasObj = null,
    moveCount = 1, //绘制移动计数器
    drawingObject = null,  //当前会话对象
    doDrawing = false, //绘画状态
    _config = {},  //配置
    signHeight = 30,  //球标的高度（等边三角）
    drawAngle = 0 //绘画的角度
  let _fabricConfig = {
    backgroundColor: '#F7F8FF',
    preserveObjectStacking: true,
    isDrawingMode: false,
    selection: false,//取消框选
  }
  window.zoom = window.zoom ? window.zoom : 1;
  let _fabricObj = new fabric.Canvas(document.getElementById(id), _fabricConfig);
  _fabricObj.freeDrawingBrush.color = color  //设置自由绘制颜色
  _fabricObj.freeDrawingBrush.width = drawWidth
  _fabricObj.selection = false; //画板不显示选中
  // createBGSVG('http://192.168.33.72:8001/Upload/SvgStyle/D-MFS-020366-100-10.svg')
  _fabricObj.on("mouse:down", (option) => {
    let xy = transformMouse(option.e.offsetX, option.e.offsetY)
    mouseFrom.x = xy.x
    mouseFrom.y = xy.y
    doDrawing = true
  })
  _fabricObj.on("object:selected", e => {
    if (e && e.target && e.target.selectable) {
    }
  });
  _fabricObj.on("mouse:up", option => {
    let xy = transformMouse(option.e.offsetX, option.e.offsetY)
    mouseTo.x = xy.x
    mouseTo.y = xy.y
    if (doDrawing && drawingObject && _config.customData.isSign) {
      let copyConfig = JSON.parse(JSON.stringify(_config))
      _config.left = mouseTo.x
      _config.top = mouseTo.y
      _config.fontSize = 12
      _config.fill = 'black'
      _config.strokeWidth = 0.1
      _config.stroke = 'black'
      setTitle(_config)
      copyConfig.isGroup = true
      let des = setSignDes(_config)
      let txt = new fabric.IText(des, _config)
      var group = new fabric.Group([drawingObject, txt], copyConfig)
      _fabricObj.remove(drawingObject)
      _fabricObj.renderAll()
      _fabricObj.add(group)
      delete copyConfig.isGroup
      _config = copyConfig
      getAllObjects()
    } else if (_config && _config.customData && _config.customData.type == 'pen') {
      getAllObjects()
    }
    moveCount = 1
    doDrawing = false
    drawingObject = null
    if (_fabricObj.getActiveObject()) {
      that.setActiveObjectCallback()
    }
  })
  _fabricObj.on('mouse:move', option => {
    if (moveCount % 2 && !doDrawing) {
      return
    }
    moveCount++
    let xy = transformMouse(option.e.offsetX, option.e.offsetY)
    mouseTo.x = xy.x
    mouseTo.y = xy.y
    if (_fabricObj.getActiveObject()) {
      return
    }
    if (doDrawing) {
      drawing()
    }
  })
  function setSignDes(_config) {
    let count = 0
    allObjects.forEach(element => {
      if (element.customData.type == _config.customData.type) {
        count++
      }
    })
    count = count < 10 ? 0 + "" + count : count
    _config.subCustomData = { des: count }
    return count
  }
  function setTitle(_config) {
    let type = _config.customData.type
    let count = 0
    allObjects.forEach(element => {
      if (element.customData.type == type) {
        count++
      }
    })
    // _config.customData.tucengName = _config.customData.label + '图层' + count
    return _config.customData.label + '图层' + count

  }
  function drawing() {
    if (_config) {
      _config = JSON.parse(JSON.stringify(_config))
    }
    if (!_fabricObj.isDrawingMode) {  //手绘不加图层等信息
      _config.top = mouseFrom.y
      _config.left = mouseFrom.x
    }
    _config.customData.tucengName = setTitle(_config)
    _config.order = allObjects.length - 1
    if (drawingObject) {
      _fabricObj.remove(drawingObject)
    }
    drawAngle = Math.atan2(mouseFrom.y - mouseTo.y, mouseFrom.x - mouseTo.x) * 180 / Math.PI
    console.log(drawAngle)
    let canvasObj = null
    switch (_config.customData.type) {
      case "arrow":
        canvasObj = drawArrowPath(_config)
        break;
      case "line": //直线
        canvasObj = drawLine(_config)
        break;
      case "dottedline": //虚线
        canvasObj = drawDottedLine(_config)
        break;
      case "circle": //正圆
        canvasObj = drawCircle(_config)
        break;
      case "ellipse": //椭圆
        canvasObj = drawEllipse(_config)
        break;
      case "rectangle": //长方形
        canvasObj = drawRectAngle(_config)
        //也可以使用fabric.Rect
        break;
      case "text":
        canvasObj = drawTxt(_config)
        break;
      case "img":
        canvasObj = drawImg()
        break;
      case "triangle": //等边三角形
        canvasObj = drawTriangle(_config)
        break;
      case "signTriangle": //球标三角形
        canvasObj = drawSignGroup(_config)
        break;
      case "signCircle": //球标圆
        canvasObj = drawSignGroup(_config)
        break;
      case "signRect": //球标矩形
        canvasObj = drawSignGroup(_config)
        break;
      case "signDiamond": //球标菱形
        canvasObj = drawSignGroup(_config)
        break;
      case "pen": //球标菱形
        // canvasObj = drawSignGroup(_config)
        _fabricObj.customData = _config.customData
        _fabricObj.order = _config.order
        break;
    }
    if (canvasObj) {
      addObj(canvasObj)
    }
  }
  function addObj(canvasObj) {
    // canvasObj.id = new Date().getTime()
    _fabricObj.add(canvasObj) //.setActiveObject(canvasObject)
    drawingObject = canvasObj
    getAllObjects()
  }
  function drawTriangle(_config) {
    let height = mouseTo.y - mouseFrom.y;
    if (_config.customData.isSign) {
      height = signHeight
      _config.left = mouseTo.x
      _config.top = mouseTo.y
    }
    _config.width = Math.sqrt(Math.pow(height, 2) + Math.pow(height / 2.0, 2))
    _config.height = height
    let canvasObj = new fabric.Triangle(_config)
    return canvasObj
  }
  function drawPolygon(_config, points) {
    let canvasObj = new fabric.Polygon(points, _config)
    return canvasObj
  }
  function drawRectAngle(_config) {
    var path =
      "M " +
      mouseFrom.x +
      " " +
      mouseFrom.y +
      " L " +
      mouseTo.x +
      " " +
      mouseFrom.y +
      " L " +
      mouseTo.x +
      " " +
      mouseTo.y +
      " L " +
      mouseFrom.x +
      " " +
      mouseTo.y +
      " L " +
      mouseFrom.x +
      " " +
      mouseFrom.y +
      " z";
    let canvasObj = new fabric.Path(path, _config)
    // addObj(canvasObj)
    return canvasObj
  }
  function drawEllipse(_config) {
    let radius = Math.sqrt((mouseTo.x - _config.left) * (mouseTo.x - _config.left) + (mouseTo.y - _config.top) * (mouseTo.y - _config.top)) / 2;
    _config.radius = radius
    _config.rx = Math.abs(_config.left - mouseTo.x)
    _config.ry = Math.abs(_config.top - mouseTo.y)
    let canvasObj = new fabric.Ellipse(_config)
    // addObj(canvasObj)
    return canvasObj
  }
  function drawCircle(_config) {
    let radius = Math.sqrt((mouseTo.x - _config.left) * (mouseTo.x - _config.left) + (mouseTo.y - _config.top) * (mouseTo.y - _config.top)) / 2;
    _config.radius = radius
    if (_config.customData.isSign) {
      _config.radius = signHeight / 2
    }
    let canvasObj = new fabric.Circle(_config);
    // addObj(canvasObj)
    return canvasObj
  }
  function drawDottedLine(_config) {
    _config.strokeDashArray = [3, 1]
    delete _config.top
    delete _config.left
    let canvasObj = new fabric.Line([mouseFrom.x, mouseFrom.y, mouseTo.x, mouseTo.y], _config)
    // addObj(canvasObj)
    return canvasObj
  }
  function drawLine(_config) {
    delete _config.top
    delete _config.left
    let toX = mouseTo.x
    let toY = mouseTo.y
    if (_config.customData.isSign) {
      let angle = drawAngle
      toX = toX + (signHeight / 2 + 2.8) * Math.cos(angle * Math.PI / 180)
      toY = toY + (signHeight / 2 + 2.8) * Math.sin(angle * Math.PI / 180)
    }
    let canvasObj = new fabric.Line([mouseFrom.x, mouseFrom.y, toX, toY], _config)
    // addObj(canvasObj)
    return canvasObj
  }
  function drawSignGroup(_config, type) {  //标记组
    delete _config.top
    delete _config.left
    let canvasObj = null
    let copyConfig = JSON.parse(JSON.stringify(_config))
    let lineConfig = JSON.parse(JSON.stringify(_config))
    let line = drawLine(lineConfig)
    let secondCanvasObj = null
    // copyConfig.fill='white'
    if (_config.customData.isSign && _config.customData.type == 'signCircle') {  //圆组，采用path路径，没有用到group，后期可能要改成group类型
      // canvasObj = new fabric.Path(drawSignCircle(mouseFrom.x, mouseFrom.y, mouseTo.x, mouseTo.y, 30, 30), copyConfig)
      copyConfig.top = mouseTo.y
      copyConfig.left = mouseTo.x
      secondCanvasObj = drawCircle(copyConfig)
    } else if (_config.customData.isSign && _config.customData.type == 'signTriangle') {  //三角形组
      copyConfig.angle = drawAngle + 90
      secondCanvasObj = drawTriangle(copyConfig)
    } else if (_config.customData.isSign && (_config.customData.type == 'signRect' || _config.customData.type == 'signDiamond')) {  //矩形组
      copyConfig.left = mouseTo.x
      copyConfig.top = mouseTo.y
      let points = [{ x: mouseTo.x - signHeight / 2, y: mouseTo.y },
      { x: mouseTo.x + signHeight / 2, y: mouseTo.y },
      { x: mouseTo.x + signHeight / 2, y: mouseTo.y + signHeight },
      { x: mouseTo.x - signHeight / 2, y: mouseTo.y + signHeight }
      ]
      copyConfig.angle = _config.customData.type == 'signDiamond' ? (135 + drawAngle) : 90 + drawAngle
      copyConfig.width = signHeight
      copyConfig.height = signHeight
      secondCanvasObj = drawPolygon(copyConfig, points)
    }
    // line.clipPath=secondCanvasObj
    // if (type != 'signCircle') {
    canvasObj = new fabric.Group([line, secondCanvasObj], _config)
    //}

    return canvasObj
  }
  function drawArrowPath(_config, type) {
    let canvasObj = null
    delete _config.left
    delete _config.top
    canvasObj = new fabric.Path(drawArrow(mouseFrom.x, mouseFrom.y, mouseTo.x, mouseTo.y, 30, 30), _config)
    // addObj(canvasObj)
    return canvasObj
  }
  function drawTxt(_config) {
    _config.left = mouseFrom.x
    _config.top = mouseFrom.y
    _config.fontSize = 16
    _config.strokeWidth = 0.1
    _config.fontWeight = 'normal'
    _config.stroke = 'black'
    _config.fill = 'black'
    let canvasObj = new fabric.IText('文本', _config)
    doDrawing = false
    // addObj(canvasObj)
    return canvasObj
  }
  function drawSignPolygon(fromX, fromY, toX, toY, theta, headLen) {
    let line = drawLine(_config)
    // path += polyline2path([toX-disx, toY, toX+disx, toY,toX+disx,toY-disy,toX-disx,toY-disy])
    return path
  }
  function drawSignPolygon2(fromX, fromY, toX, toY, theta, headLen) {
    theta = typeof theta != 'undefined' ? theta : 30
    headLen = typeof theta != "undefined" ? headLen : 10
    let angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
      angle1 = (angle + theta) * Math.PI / 180,
      angle2 = (angle - theta) * Math.PI / 180,
      topX = headLen * Math.cos(angle1),
      topY = headLen * Math.sin(angle1),
      botX = headLen * Math.cos(angle2),
      botY = headLen * Math.sin(angle2)
    let arrowX = fromX - topX,
      arrowY = fromY - topY
    let path = " M " + fromX + " " + fromY
    path += " L " + toX + " " + toY
    let disx = 10, disy = 20, dis = 20
    let deg = 45 * Math.PI / 180
    let x1 = toX,
      y1 = toY,
      x2 = x1 + disx * Math.cos(deg),
      y2 = y1 + dis * Math.sin(deg),
      x3 = x1,
      y3 = y1 + 2 * dis * Math.sin(deg),
      x4 = x1 - dis * Math.cos(deg),
      y4 = x1 + dis * Math.sin(deg)
    path += polyline2path([x1, y1, x2, y2, x3, y3, x4, y4])
    // path += polyline2path([toX-disx, toY, toX+disx, toY,toX+disx,toY-disy,toX-disx,toY-disy])
    return path
  }
  function drawSignCircle(fromX, fromY, toX, toY, theta, headLen) {
    theta = typeof theta != 'undefined' ? theta : 30
    headLen = typeof theta != "undefined" ? headLen : 10
    let angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
      angle1 = (angle + theta) * Math.PI / 180,
      angle2 = (angle - theta) * Math.PI / 180,
      topX = headLen * Math.cos(angle1),
      topY = headLen * Math.sin(angle1),
      botX = headLen * Math.cos(angle2),
      botY = headLen * Math.sin(angle2)
    let arrowX = fromX - topX,
      arrowY = fromY - topY
    let path = " M " + fromX + " " + fromY
    path += " L " + toX + " " + toY
    path += ellipse2path(toX, toY, signHeight / 2, signHeight / 2)
    return path
  }
  function drawArrow(fromX, fromY, toX, toY, theta, headLen) {
    theta = typeof theta != 'undefined' ? theta : 30
    headLen = typeof theta != "undefined" ? headLen : 10
    let angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
      angle1 = (angle + theta) * Math.PI / 180,
      angle2 = (angle - theta) * Math.PI / 180,
      topX = headLen * Math.cos(angle1),
      topY = headLen * Math.sin(angle1),
      botX = headLen * Math.cos(angle2),
      botY = headLen * Math.sin(angle2)
    let arrowX = fromX - topX,
      arrowY = fromY - topY
    let path = " M " + fromX + " " + fromY;
    path += " L " + toX + " " + toY;
    arrowX = toX + topX;
    arrowY = toY + topY;
    path += " M " + arrowX + " " + arrowY;
    path += " L " + toX + " " + toY;
    arrowX = toX + botX;
    arrowY = toY + botY;
    path += " L " + arrowX + " " + arrowY
    return path
  }
  function drawImg(_config) { }
  function createBGIMG(url, endCallback, type) {
    if (type == 'clear') {
      _fabricObj.clear()
      getAllObjects()
    }
    if (imgInstance) {
      _fabricObj.remove(imgInstance)
    }
    imgInstance = new fabric.Image.fromURL(url, img => {
      let sourceW = img.width + 80
      let sourceH = img.height
      let scalX = _fabricObj.width / sourceW
      let scalY = _fabricObj.height / sourceH
      // img.setAttribute('crossOrigin', 'anonymous')
      img.crossOrigin = 'Anonymous'
      // img.setCrossOrigin('Anonymous')
      img.set({
        left: 10,
        top: 20,
        scaleY: scalY,
        scaleX: scalX
      })
      _fabricObj.setBackgroundImage(img)
      _fabricObj.renderAll()
      if (endCallback) {
        endCallback()
      }
    })
  }
  function createBGSVG(url, callback) {
    if (imgInstance) {
      _fabricObj.remove(imgInstance)
    }
    _fabricObj.clear()
    imgInstance = new fabric.loadSVGFromURL(url, (objects, options) => {
      var shape = fabric.util.groupSVGElements(objects, options)
      let sourceW = options.width + 80
      let sourceH = options.height
      let scalX = _fabricObj.width / sourceW
      let scalY = _fabricObj.height / sourceH
      shape.set({
        left: -10,
        top: 20,
        scaleY: scalY,
        scaleX: scalX
        // selectable: false
      });
      // // shape.setCoords();
      // shape.hasControls = false;
      // shape.set("lockRotation", true);
      // shape.set("lockScalingX", true);
      // shape.set("lockScalingY", true);
      // shape.set("lockMovementX", true);
      // shape.set("lockMovementY", true);
      // _fabricObj.add(shape);
      // _fabricObj.setActiveObject(shape);
      _fabricObj.setBackgroundImage(shape)
      _fabricObj.renderAll()
      if (callback) {
        callback()
      }
    })

  }
  function setDrawConfig(config) {
    _config = {}
    _config.customData = config.data
    _config.originX = 'center'
    _config.originY = 'center'
    _config.visible = true
    _config.stroke = color
    _config.strokeWidth = 2
    _config.fill = fill
    if (config.hasOwnProperty('isDrawingMode')) {
      _fabricObj.isDrawingMode = config.isDrawingMode
      // _config = {}
      // _config.customData = config.data
      return
    }
    _fabricObj.isDrawingMode = false
  }
  function loadJsonObj(json) {
    // _fabricObj.loadFromJSON(json, _fabricObj.renderAll.bind(_fabricObj))
    fabric.util.enlivenObjects(json, options => {
      let origRenderOnAddRemove = _fabricObj.renderOnAddRemove;
      _fabricObj.renderOnAddRemove = false;
      options.forEach(function (o) {
        _fabricObj.add(o);
      });
      _fabricObj.renderOnAddRemove = origRenderOnAddRemove;
      _fabricObj.renderAll()
    })
    getAllObjects()
  }
  function getAllObjects() {
    allObjects = []
    let objs = _fabricObj.getObjects()
    objs.forEach(element => {  //手绘的不加图层
      if (element.canvas.isDrawingMode) {  //手绘
        let _obj = {
          order: element.canvas.order,
          customData: element.canvas.customData
        }
        if (element.hasOwnProperty('order') && element.hasOwnProperty('customData')) {
          _obj.order = element.order
          _obj.customData = element.customData
        } else {
          element.order = element.canvas.order
          element.customData = element.canvas.customData
          delete element.canvas.order
          delete element.canvas.customData
        }
        for (const key in element) {
          if (typeof (element[key]) == 'string') {
            _obj[key] = element[key]
          }
        }
        allObjects.unshift(_obj)
      } else if (element.customData) {
        let _obj = {
          visible: element.visible,
          order: element.order,
          customData: element.customData
        }
        for (const key in element) {
          if (typeof (element[key]) == 'string') {
            _obj[key] = element[key]
          }
        }
        if (element.customData && element.customData.isSign && element.isGroup && element.item(1) && element.item(1).subCustomData) {  //球标
          console.log(element)
          _obj.isGroup = true
          _obj.subCustomData = element.item(1).subCustomData
        }
        allObjects.unshift(_obj)
      }
      // allObjects.push(JSON.parse(JSON.stringify(element)))
    });
    that.$bus.$emit('getAllObjects', allObjects)
  }
  function findObj(list, value, key) {
    return list.filter(e => {
      return e && e[key] == value
    })
  }
  function toggleVisiable(value, order) {
    let obj = findObj(_fabricObj.getObjects(), order, 'order')
    if (obj && obj.length > 0) {
      obj[0].set('visible', value)
      if (!value) {
        _fabricObj.discardActiveObject()
      }
      _fabricObj.renderAll()
    }
  }
  function delObj(order) {
    let obj = findObj(_fabricObj.getObjects(), order, 'order')
    if (obj && obj.length > 0) {
      _fabricObj.remove(obj[0])
      _fabricObj.renderAll()
      getAllObjects()
    }
  }
  function setActiveSelect(order,callback) {
    let obj = findObj(_fabricObj.getObjects(), order, 'order')
    if (obj && obj.length > 0) {
      _fabricObj.setActiveObject(obj[0])
      _fabricObj.renderAll()
      callback()
    }
  }
  function updateLevel(moveOrder, movedOrder, order) {
    moveOrder = parseInt(moveOrder);
    movedOrder = parseInt(movedOrder);
    let upLevels = _fabricObj.getObjects();
    let currentUpdate = null;
    currentUpdate = findObj(upLevels, order, 'order')
    if (currentUpdate.length == 0) return
    currentUpdate = currentUpdate[0]
    if (moveOrder < movedOrder) {
      //移动图层,往下移动
      for (let m = moveOrder; m < movedOrder; m++) {
        _fabricObj.sendBackwards(currentUpdate); //下移
      }
    } else {
      //移动图层,往上移动
      for (let k = movedOrder; k < moveOrder; k++) {
        _fabricObj.bringForward(currentUpdate); //上移
      }
    }
    _fabricObj.renderAll();
  }
  function setProperty(obj, data, property) {
    if (typeof (data) == 'object') {
      let temp = obj.get(property)
      for (const key in data) {
        temp[key] = data[key]
      }
      obj.set(property, temp)
    } else {
      obj.set(property, data)
    }
  }
  function set(order, property, val, type) {
    let obj = findObj(_fabricObj.getObjects(), order, 'order')
    if (obj && obj.length > 0) {
      let subObj = null
      if (type == 'sub') {
        subObj = obj[0].item(1)
        setProperty(subObj, val, property)
      } else {
        setProperty(obj[0], val, property)
      }
      _fabricObj.renderAll()
    }
  }
  function exportJson() {
    let objects = _fabricObj.getObjects()
    let list = []
    iteratorObj(objects, list)  //自己写导出json数据，自带的api方法导不出自定义的属性
    return list
  }
  function iteratorObj(objects, list) {
    objects.forEach(element => {
      let obj = {}
      obj = JSON.parse(JSON.stringify(element))
      if (element.customData) {
        obj.customData = JSON.parse(JSON.stringify(element.customData))
      }
      if (element.subCustomData) {
        obj.subCustomData = JSON.parse(JSON.stringify(element.subCustomData))
      }
      if (element.isGroup) {
        obj.isGroup = element.isGroup
      }
      if (element.order) {
        obj.order = element.order
      }
      if (obj.hasOwnProperty('objects')) {
        let temp = element._objects
        obj.objects = []
        iteratorObj(temp, obj.objects)
      }
      list.push(obj)
    });
  }
  function exportPng() {
    let width = _fabricObj.width
    let height = _fabricObj.height
    try {
      // _fabricObj.crossOrigin = "Anonymous"
      let imgURL = _fabricObj.toDataURL({
        crossOrigin: 'Anonymous',
        format: 'png',
        quality: 1,
        multiplier: 1,
        left: 0,
        top: 0,
        width: width,
        height: height
      })
      return imgURL
    } catch (e) {
      console.log(e)
      return ''
    }

    // let dlLink = document.createElement('a');
    // let filename = '合成图_' + (new Date()).getTime() + '.png';
    // dlLink.download = filename;
    // dlLink.href = imgURL;
    // dlLink.dataset.downloadurl = ['image/png', dlLink.download, dlLink.href].join(':');
    // document.body.appendChild(dlLink);
    // dlLink.click();
    // document.body.removeChild(dlLink);
  }
  return {
    setDrawConfig: setDrawConfig,
    fabricObjInst: _fabricObj,
    loadJsonObj: loadJsonObj,
    toggleVisiable: toggleVisiable,
    setActiveSelect: setActiveSelect,
    delObj: delObj,
    createBGIMG: createBGIMG,
    createBGSVG: createBGSVG,
    updateLevel: updateLevel,
    set: set,
    exportJson: exportJson,
    exportPng: exportPng
  }
}
function transformMouse(mouseX, mouseY) {
  return { x: mouseX / window.zoom, y: mouseY / window.zoom };
}
function ellipse2path(cx, cy, rx, ry) {
  if (isNaN(cx - cy + rx - ry)) return
  var path =
    'M' + (cx - rx) + ' ' + cy +
    'a' + rx + ' ' + ry + ' 0 1 0 ' + 2 * rx + ' 0' +
    'a' + rx + ' ' + ry + ' 0 1 0 ' + (-2 * rx) + ' 0' +
    'z'
  return path
}
function line2path(x1, y1, x2, y2) {
  if (isNaN(x1 - y1 + x2 - y2)) return
  x1 = x1 || 0
  y1 = y1 || 0
  x2 = x2 || 0
  y2 = y2 || 0
  var path = 'M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2
  return path
}
function polyline2path(points) {
  var path = 'M' + points.slice(0, 2).join(' ') +
    'L' + points.slice(2).join(' ')
  return path
}
function rect2path(x, y, width, height, rx, ry) {
  /* * rx 和 ry 的规则是： * 1. 如果其中一个设置为 0 则圆角不生效 * 2. 如果有一个没有设置则取值为另一个 */
  rx = rx || ry || 0;
  ry = ry || rx || 0; //非数值单位计算，如当宽度像100%则移除 
  if (isNaN(x - y + width - height + rx - ry))
    return
  rx = rx > width / 2 ? width / 2 : rx
  ry = ry > height / 2 ? height / 2 : ry
  //如果其中一个设置为 0 则圆角不生效 
  if (0 == rx || 0 == ry) {
    // var path = 
    // 'M' + x + ' ' + y + 
    // 'H' + (x + width) + 不推荐用绝对路径，相对路径节省代码量 
    // 'V' + (y + height) + 
    // 'H' + x + // 'z'; 
    var path = 'M' + x + ' ' + y + 'h' + width + 'v' + height + 'h' + -width + 'z'
  } else {
    var path =
      'M' + x + ' ' + (y + ry) +
      'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + (-ry) +
      'h' + (width - rx - rx) +
      'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + ry +
      'v' + (height - ry - ry) +
      'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + ry +
      'h' + (rx + rx - width) +
      'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + (-ry) + 'z'
  }
  return path
}
function polygon2path(points) {
  var path = 'M' + points.slice(0, 2).join(' ') + 'L' + points.slice(2).join(' ') + 'z'
  return path
}
export {
  fabricObject
}


// WEBPACK FOOTER //
// ./src/components/editImg/js/fabricOperate.js